import React from 'react';
import store from "./Store";
import { Provider } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import ReduxToastr from 'react-redux-toastr';
import validate from 'validate.js';


import theme from './theme';
import { Loading }  from './common/components';
import { AppRouter } from "./AppRouter";

const browserHistory = createBrowserHistory();

validate.validators = {
  ...validate.validators
};

export function App() {
  return (
      <Provider store={ store }>
        <ThemeProvider theme={ theme }>
          <CssBaseline />
          <Router history={ browserHistory }>
            <AppRouter/>
          </Router>
        </ThemeProvider>
        <ReduxToastr timeOut={4000} />
        <Loading />
      </Provider>
  );
}
